import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {BannerFlexLink} from '../../atoms/Banner/BannerFlexLink';
import {BannerTitle} from './BannerTitle';

interface CampaignTopBannerTitleProps {
  title: string;
  superText?: string;
  bannerLink?: string;
  reduced?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const CampaignBannerTitle: FC<CampaignTopBannerTitleProps> = ({
  title,
  superText,
  bannerLink,
  reduced,
  className,
  style,
}) => {
  if (title.length === 0) {
    return null;
  }

  return (
    <Container
      to={bannerLink}
      id="campaign-top-banner-title"
      data-testid="campaign-top-banner-title-wrapper"
      as={bannerLink ? BannerFlexLink : 'div'}
    >
      <BannerTitle
        boldTitle={!reduced}
        title={title}
        superText={superText}
        bannerAlignment="center"
        defaultSize={reduced ? 'px12' : 'px18'}
        className={className}
        style={style}
      />
    </Container>
  );
};

export const Container = styled.div<{
  to: string | undefined;
}>``;
